import { createSlice } from "@reduxjs/toolkit";
import { FilterStateConciliationEmails } from "./types";

const INITIAL_STATE: FilterStateConciliationEmails = {
  filters: {
    search: "",
    order: {},
    meta: {
      page: 1,
      perPage: 10,
    },
  },
};

const conciliationEmailsFilterSlice = createSlice({
  name: "conciliationEmailFilter",
  initialState: INITIAL_STATE,
  reducers: {
    setConciliationEmailsFilter(state, action) {
      state.filters[action.payload.key] = action.payload.value;
    },
  },
});

export const { setConciliationEmailsFilter } = conciliationEmailsFilterSlice.actions;
export default conciliationEmailsFilterSlice.reducer;
